"use client";

import { useMemo } from "react";
import { useQuery } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";

interface CreatorReferralStatus {
  codeType: "member" | "creator";
  creatorName: string | null;
  hasTrackedPurchase: boolean;
  discountRewardId: string | null;
}

export const useCreatorReferralReward = () => {
  const status = useQuery(api.referrals.getMyCreatorReferralStatus, {});

  return useMemo(() => {
    if (status === undefined) {
      return {
        loading: true,
        shouldApply: false,
        rewardId: null as string | null,
        status: undefined as CreatorReferralStatus | undefined,
      };
    }

    if (status === null) {
      return {
        loading: false,
        shouldApply: false,
        rewardId: null as string | null,
        status: null as CreatorReferralStatus | null,
      };
    }

    const creatorStatus = status as CreatorReferralStatus;
    const rewardId = creatorStatus.discountRewardId;
    const shouldApply =
      creatorStatus.codeType === "creator" &&
      !!rewardId &&
      !creatorStatus.hasTrackedPurchase;

    return {
      loading: false,
      shouldApply,
      rewardId,
      status: creatorStatus,
    };
  }, [status]);
};
